/**
 * VideoMotion Studio credit costs — TS source of truth.
 * Keep in sync with apps/videomotion/constants.ts until the app imports these.
 */

export const VIDEOMOTION_CREDITS_FOR_SCRIPT = 1;
/** Analysis is free; starting it needs the export price on the balance. */
export const VIDEOMOTION_CREDITS_FOR_ANALYSIS = 0;
/** Flat price for a finished video. Charged on a project's first export; re-exports are free. */
export const VIDEOMOTION_CREDITS_FOR_EXPORT = 5;
export const VIDEOMOTION_CREDITS_TOTAL_PER_VIDEO =
  VIDEOMOTION_CREDITS_FOR_ANALYSIS + VIDEOMOTION_CREDITS_FOR_EXPORT;

export function formatVideomotionCredits(amount: number): string {
  return amount === 1 ? '1 credit' : `${amount} credits`;
}

export const VIDEOMOTION_MAX_VIDEOS_PER_PROJECT = 10;
export const VIDEOMOTION_MAX_FILE_SIZE_MB = 500;
export const VIDEOMOTION_MAX_DURATION_SECONDS = 300;
export const VIDEOMOTION_MEDIA_EXPIRY_DAYS = 30;

export const VIDEOMOTION_CREDIT_COPY = {
  script: `${formatVideomotionCredits(VIDEOMOTION_CREDITS_FOR_SCRIPT)} per AI script generate or regenerate`,
  analysis: 'Free. You pay when you export.',
  export: `${formatVideomotionCredits(VIDEOMOTION_CREDITS_FOR_EXPORT)} on your first export. Re-exports are free.`,
  total: `${formatVideomotionCredits(VIDEOMOTION_CREDITS_TOTAL_PER_VIDEO)} per finished video, excluding optional scripts`,
} as const;
